"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEntityAdded = void 0;
/**
 * @public
 * Emitted on entity added to plot.
 */
class OnEntityAdded {
    constructor(onEntityAdded) {
        this.onEntityAdded = onEntityAdded;
    }
    static registerListener(owner, onEvent) {
        return owner.eventService
            .getCategory(OnEntityAdded)
            .addTemporaryListener(new OnEntityAdded(onEvent));
    }
    static registerOneTimeListener(owner, onEvent) {
        return owner.eventService
            .getCategory(OnEntityAdded)
            .addOneTimeListener(new OnEntityAdded(onEvent));
    }
    static emit(eventService, entity) {
        const listeners = eventService
            .getCategory(OnEntityAdded)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onEntityAdded(entity);
        }
    }
}
exports.OnEntityAdded = OnEntityAdded;
OnEntityAdded.callbackKey = "onEntityAdded";
//# sourceMappingURL=on-entity-added.js.map